"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CircuitBreakers = _interopRequireDefault(require("./CircuitBreakers"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../constants");

var _common = _interopRequireDefault(require("../../../utils/common"));

var _Busbar = _interopRequireDefault(require("./Busbar"));

var _excluded = ["asset", "mode"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SVG(_ref) {
  var asset = _ref.asset,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? _constants.core.MODE.VIEW : _ref$mode,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var TxId = _constants.core.ASSET_PREFIX + asset.txId;

  var title = _common.default.calculateTitleText(asset);

  var objectType = asset.altTxt ? _common.default.getSVGType(asset.altTxt) : (asset === null || asset === void 0 ? void 0 : asset.className) === "breaker" ? "circuitBreaker" : asset === null || asset === void 0 ? void 0 : asset.className;

  var renderSVG = function renderSVG(type, fillColor) {
    switch (type) {
      case 'circuitBreaker':
        return /*#__PURE__*/_react.default.createElement(_CircuitBreakers.default, {
          color: fillColor
        });

      case 'busbar':
        return /*#__PURE__*/_react.default.createElement(_Busbar.default, _extends({}, asset.propsStyle, {
          className: asset === null || asset === void 0 ? void 0 : asset.className
        }));

      case 'feeder':
        return /*#__PURE__*/_react.default.createElement(_Busbar.default, _extends({}, asset.propsStyle, {
          isHorizontal: false,
          className: asset === null || asset === void 0 ? void 0 : asset.className
        }));

      default:
        return null;
    }
  };

  var getCBColor = function getCBColor(objectType) {
    if (mode === _constants.core.MODE.EDIT) return _constants.CB.color.GREY;
    return _common.default.getSVGColor(asset);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    onContextMenu: otherProps.onContextMenu,
    onMouseUp: otherProps.onMouseUp && otherProps.onMouseUp,
    style: {
      width: 'inherit',
      height: 'inherit',
      background: 'none',
      overflow: 'none',
      zIndex: '100'
    },
    id: TxId,
    className: asset.className,
    alt: TxId,
    draggable: mode === _constants.core.MODE.EDIT,
    title: title,
    "data-issvg": true
  }, renderSVG(objectType, getCBColor(objectType)));
}

SVG.propTypes = {
  mode: _propTypes.default.string.isRequired,
  asset: _propTypes.default.shape({
    className: _propTypes.default.string,
    txId: _propTypes.default.string.isRequired,
    altTxt: _propTypes.default.string
  }).isRequired,
  onContextMenu: _propTypes.default.func,
  onMouseUp: _propTypes.default.func
};
var _default = SVG;
exports.default = _default;